import { getCurrentInstance, reactive, watch } from 'vue';

/**
 * Composable per accedere al router in Vue 2.7 + Nuxt 2
 * Wrapper around this.$router con type safety
 */
export function useRouter() {
	const instance = getCurrentInstance();
	if (!instance) {
		throw new Error('useRouter must be called within a setup function');
	}

	return (instance.proxy as any).$router;
}

/**
 * Composable per accedere alla route corrente in Vue 2.7 + Nuxt 2
 * Wrapper around this.$route con type safety e reattività
 */
export function useRoute() {
	const instance = getCurrentInstance();
	if (!instance) {
		throw new Error('useRoute must be called within a setup function');
	}

	const proxy = instance.proxy as any;

	// Creiamo un oggetto reattivo che si sincronizza con $route
	const route = reactive({
		path: proxy.$route.path,
		name: proxy.$route.name,
		params: proxy.$route.params,
		query: proxy.$route.query,
		meta: proxy.$route.meta,
		fullPath: proxy.$route.fullPath,
		hash: proxy.$route.hash,
		matched: proxy.$route.matched,
	});

	// Sincronizziamo il reactive object con $route quando cambia
	watch(
		() => proxy.$route,
		(newRoute) => {
			route.path = newRoute.path;
			route.name = newRoute.name;
			route.params = newRoute.params;
			route.query = newRoute.query;
			route.meta = newRoute.meta;
			route.fullPath = newRoute.fullPath;
			route.hash = newRoute.hash;
			route.matched = newRoute.matched;
		},
		{ immediate: true, deep: true },
	);

	return route;
}

/**
 * Composable per accedere a Nuxt context helpers
 */
export function useNuxtHelpers() {
	const instance = getCurrentInstance();
	if (!instance) {
		throw new Error('useNuxtHelpers must be called within a setup function');
	}

	const proxy = instance.proxy as any;

	return {
		$store: proxy.$store,
		$nuxt: proxy.$nuxt,
		$confirm: proxy.$confirm,
		$notificationService: proxy.$notificationService,
	};
}
